angular.module('localStorage', [])
.service("localStorageService",['$window', function($window){
  
  this.get = function(key){
    return $window.localStorage.getItem(key);
  }
  
  this.set = function(key, value){
    $window.localStorage.setItem(key, value);
  }

  this.remove = function(key){
    $window.localStorage.removeItem(key);
  }
}]);